import styled from '@emotion/styled';
import { Card } from 'ui-components/Card'

export const Container = styled(Card)`
  margin-top: 20px; 
`

export const Total = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: solid 1px rgb(210,210,210);

  &:hover {
    background-color: rgb(240,240,240);
  }
`

export const Label = styled.div`
  display: grid;
  grid-template-columns: 15px auto;
`

export const Legend = styled.div`
  width: 10px;
  height: 10px;
  margin-top: 3px;

  &.dark-yellow {
    background-color: #ff9800;
  }

  &.green {
    background-color: #4caf50;
  }

  &.orange {
    background-color: #e3650b;
  }

  &.blue {
    background-color: #2196f3;
  }
`
